import { useState, useCallback, useEffect } from 'react';

type SelectedRiskSettingsProps = {
  value: string;
  label: string;
  isDefault?: boolean;
};

export const useRiskSettings = (
  setRiskSettingsSelected: any,
  key: string,
  initialItems: SelectedRiskSettingsProps[] = [],
) => {
  const [selectedItems, setSelectedItems] = useState<SelectedRiskSettingsProps[]>(initialItems);

  const handleChange = useCallback(
    (options: SelectedRiskSettingsProps[]) => {
      const mappedOptions =
        key === 'volShocks'
          ? options.map((option) => Number(option.value)).sort((a, b) => a - b)
          : options.map((option) => option.value).sort();

      setSelectedItems(options);
      setRiskSettingsSelected((state: any) => ({ ...state, [key]: mappedOptions }));
    },
    [setRiskSettingsSelected, key],
  );

  useEffect(() => {
    if (initialItems.length > 0) {
      handleChange(initialItems);
    }
  }, []);

  return {
    selectedItems,
    handleChange,
  };
};
